import { useAtomValue, useSetAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { FieldRow, SegmentedControl } from '@/core/ui';
import { setModeAtom } from '../state/actions';
import { modeAtom } from '../state/atoms';

/** Fly (from a takeoff) or hike (to a landing zone). */
export function ModeField() {
  const { t } = useTranslation('glide');
  const mode = useAtomValue(modeAtom);
  const setMode = useSetAtom(setModeAtom);
  return (
    <FieldRow group label={t('settings.mode')}>
      <SegmentedControl
        compact
        className="min-w-[120px]"
        options={[
          { value: 'fly', label: t('mode.fly') },
          { value: 'hike', label: t('mode.hike') },
        ]}
        value={mode}
        onChange={setMode}
      />
    </FieldRow>
  );
}
